
export default function(string) {
  return string.replace(/\[\/?(?:b|i|u|url|quote|code|img|color|size)*?.*?\]/img, '');
} 



/** WEBPACK FOOTER **
 ** ./src/__shared__/bbCodeRemover.js
 **/